import { hash } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';
import { coreActions } from '../core-actions';

import * as actions from './alertsActions';

const alertsReducer = handleActions(
  {
    [coreActions.sanitize]: (state) =>
      state.set(
        'resourcesById',
        state.resourcesById.map((resource) =>
          resource.merge({
            message: hash(resource.message).toString(),
          }),
        ),
      ),

    [actions.updateAlert]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateAlert),
    [actions.updateAlertSuccess]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.getAlerts]: (state) => state.merge({ isLoading: true }),
    [actions.getAlertsSuccess]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getAlertsFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [actions.deleteAlert]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.deleteAlertSuccess]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.batchAlerts]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchAlerts, false),

    [actions.batchAlertsSuccess]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchAlerts, true),

    [combineActions(actions.updateAlertFailure, actions.deleteAlertFailure, actions.batchAlertsFailure)]: (
      state,
      { payload: error, asyncDispatch },
    ) => {
      asyncDispatch(actions.getAlerts());
      return resourceUpserters.resetResources(state, error);
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const ALERTS_REDUCER_KEY = 'alertsStore';
export default alertsReducer;
